import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CurrencyProviderService {
  public getMainCurrencyList(): Array<Currency> {
    return [
      {value: null},
      {value: 'EUR'},
      {value: 'CHF'},
      {value: 'GBP'},
      {value: 'USD'},
      {value: '999'}
    ];
  }

  public getOtherCurrencyList(): Array<Currency> {
    return [
      {value: 'AED'},
      {value: 'AFN'},
      {value: 'ALL'},
      {value: 'AMD'},
      {value: 'AOA'},
      {value: 'ARS'},
      {value: 'AUD'},
      {value: 'AWG'},
      {value: 'AZN'},
      {value: 'BAM'},
      {value: 'BBD'},
      {value: 'BDT'},
      {value: 'BGN'},
      {value: 'BHD'},
      {value: 'BIF'},
      {value: 'BMD'},
      {value: 'BND'},
      {value: 'BOB'},
      {value: 'BOV'},
      {value: 'BRL'},
      {value: 'BSD'},
      {value: 'BTN'},
      {value: 'BWP'},
      {value: 'BYR'},
      {value: 'BZD'},
      {value: 'CAD'},
      {value: 'CDF'},
      {value: 'CHE'},
      {value: 'CHF'},
      {value: 'CHW'},
      {value: 'CLF'},
      {value: 'CLP'},
      {value: 'CMG'},
      {value: 'CNY'},
      {value: 'COP'},
      {value: 'COU'},
      {value: 'CRC'},
      {value: 'CUC'},
      {value: 'CUP'},
      {value: 'CVE'},
      {value: 'CZK'},
      {value: 'DJF'},
      {value: 'DKK'},
      {value: 'DOP'},
      {value: 'DZD'},
      {value: 'EGP'},
      {value: 'ERN'},
      {value: 'ETB'},
      {value: 'EUR'},
      {value: 'FJD'},
      {value: 'FKP'},
      {value: 'GBP'},
      {value: 'GEL'},
      {value: 'GHS'},
      {value: 'GIP'},
      {value: 'GMD'},
      {value: 'GNF'},
      {value: 'GTQ'},
      {value: 'GYD'},
      {value: 'HKD'},
      {value: 'HNL'},
      {value: 'HRK'},
      {value: 'HTG'},
      {value: 'HUF'},
      {value: 'IDR'},
      {value: 'ILS'},
      {value: 'INR'},
      {value: 'IQD'},
      {value: 'IRR'},
      {value: 'ISK'},
      {value: 'JMD'},
      {value: 'JOD'},
      {value: 'JPY'},
      {value: 'KES'},
      {value: 'KGS'},
      {value: 'KHR'},
      {value: 'KMF'},
      {value: 'KPW'},
      {value: 'KRW'},
      {value: 'KWD'},
      {value: 'KYD'},
      {value: 'KZT'},
      {value: 'LAK'},
      {value: 'LBP'},
      {value: 'LKR'},
      {value: 'LRD'},
      {value: 'LSL'},
      {value: 'LTL'},
      {value: 'LVL'},
      {value: 'LYD'},
      {value: 'MAD'},
      {value: 'MDL'},
      {value: 'MGA'},
      {value: 'MKD'},
      {value: 'MMK'},
      {value: 'MNT'},
      {value: 'MOP'},
      {value: 'MRO'},
      {value: 'MUR'},
      {value: 'MVR'},
      {value: 'MWK'},
      {value: 'MXN'},
      {value: 'MXV'},
      {value: 'MYR'},
      {value: 'MZN'},
      {value: 'NAD'},
      {value: 'NGN'},
      {value: 'NIO'},
      {value: 'NOK'},
      {value: 'NPR'},
      {value: 'NZD'},
      {value: 'OMR'},
      {value: 'PAB'},
      {value: 'PEN'},
      {value: 'PGK'},
      {value: 'PHP'},
      {value: 'PKR'},
      {value: 'PLN'},
      {value: 'PYG'},
      {value: 'QAR'},
      {value: 'RON'},
      {value: 'RSD'},
      {value: 'RUB'},
      {value: 'RWF'},
      {value: 'SAR'},
      {value: 'SBD'},
      {value: 'SCR'},
      {value: 'SDG'},
      {value: 'SEK'},
      {value: 'SGD'},
      {value: 'SHP'},
      {value: 'SLL'},
      {value: 'SOS'},
      {value: 'SRD'},
      {value: 'SSP'},
      {value: 'STD'},
      {value: 'SVC'},
      {value: 'SYP'},
      {value: 'SZL'},
      {value: 'THB'},
      {value: 'TJS'},
      {value: 'TMT'},
      {value: 'TND'},
      {value: 'TOP'},
      {value: 'TRY'},
      {value: 'TTD'},
      {value: 'TWD'},
      {value: 'TZS'},
      {value: 'UAH'},
      {value: 'UGX'},
      {value: 'USD'},
      {value: 'UYI'},
      {value: 'UYU'},
      {value: 'UZS'},
      {value: 'VEF'},
      {value: 'VND'},
      {value: 'VUV'},
      {value: 'WST'},
      {value: 'XAF'},
      {value: 'XCD'},
      {value: 'XOF'},
      {value: 'XPF'},
      {value: 'YER'},
      {value: 'ZAR'},
      {value: 'ZMK'},
      {value: 'ZWR'}
    ];
  }
}

export class Currency {
  public value: string;
}
